import { render, staticRenderFns } from "./RankBadge.vue?vue&type=template&id=1070c2f7&scoped=true&lang=pug&"
import script from "./RankBadge.vue?vue&type=script&lang=js&"
export * from "./RankBadge.vue?vue&type=script&lang=js&"
import style0 from "./RankBadge.vue?vue&type=style&index=0&id=1070c2f7&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1070c2f7",
  null
  
)

export default component.exports